<template>
    <!-- SAVED CARDS -->
    <div>
      <template v-if="loading">
        <pre-loader />
        <div class="loading-shade opacity-50"></div>
      </template>

      <!-- <div id="axcess-scripts"></div> -->
      <div class="btn-back desk-c-pointer" @click="onBack"> 
        <div >&#10094;</div>
        <div v-if="step==='start'">{{ backLabel }}</div>
        <div v-else-if="step==='add-card'">Add a new card</div>
        <div v-else-if="step==='pay'">Pay with card</div>
      </div>
      <hr />

      <div v-show="step === 'start'">
        <!-- Cards available-->
        <div class="card-list-wr">
          <template v-if="cardsLoading">
            <pre-loader />
            <div class="loading-shade"></div>
          </template>
          

          <div v-if="userCardList.length">
            <div class="title">Saved Cards:</div>
            <user-cards-list 
              show-del
              :list="userCardList"
              @card-click="onSavedCardClick" 
              @card-delete="onCardDelete"/>
          </div>
          <!-- No cards -->
          <div v-else class="no-cards">
            <div class="title">No saved cards</div>
          </div>
        </div>

        <vue-button
          cls="main"
          class="my-4 deposit-button"
          @click="addCard"
        >Add a new card</vue-button>
        <hr />
        <!-- <vue-button
          cls="main"
          class="my-4 deposit-button"
          @click="onOneTimePayment"
        >Pay without card saving</vue-button> -->
      </div>

      <div v-if="step === 'pay'">
        <!-- <form
          :action="redirectUrl"
          class="paymentWidgets"
          data-brands="MASTER VISA"
        > </form> -->
        <axcess-frame :return-url="redirectUrl" :script-url="paymentScriptUrl"/>
      </div>

      <div v-if="step === 'add-card'">
        <!-- <form
          :action="tokenizationUrl"
          class="paymentWidgets"
          data-brands="MASTER VISA"
        > </form> -->
        <axcess-frame :return-url="tokenizationUrl" :script-url="paymentScriptUrl"/>
      </div>
      
    </div>


</template>
  
<script>
  import moment from "moment";
  import PreLoader from "@/components/UI/PreLoader";
  import VueButton from "@/components/UI/VueButton";
  import UserCardsList from "@/components/Payments/Common/UserCardsList";
  import AxcessFrame from "@/components/Payments/Axcess/AxcessFrame";

  export default {
    name: "AxcessCardFlow",
    components: {
      PreLoader,
      VueButton,
      UserCardsList,
      AxcessFrame
    },
    emits: [
      'cardClick',
      'goBack'
    ],
    data:()=>{
      return {
        cardsLoading: true,
        userCardList: [],
        step: 'start',
        // tokenizationScriptUrl: null,
        paymentScriptUrl: null,
        loading: false,
      }
    },
    props: {
      amount: {
        type: Number
      },
      currency: { // currencyCode
        type: String
      },
      redirectUrl: {
        type: String,
      },
      tokenizationUrl: {
        type: String,
      },
      // isTest:  {
      //   type: Boolean
      // },
      backLabel: {
        type: String,
        default: 'Deposit by Card'
      }
    },
    mounted () {
      window['wpwlOptions']['onReady'] = 
      function() {
          // change order of address fields
          if (document.getElementsByClassName('wpwl-control-country')?.length) {
            if (document.getElementsByClassName('wpwl-control-street1')?.length) {
              document.getElementsByClassName('wpwl-control-country')[0].before(document.getElementsByClassName('wpwl-control-street1')[0])
            }
            if (document.getElementsByClassName('wpwl-control-street2')?.length) {
              document.getElementsByClassName('wpwl-control-country')[0].before(document.getElementsByClassName('wpwl-control-street2')[0])
            }
            if (document.getElementsByClassName('wpwl-control-city')?.length) {
              document.getElementsByClassName('wpwl-control-country')[0].before(document.getElementsByClassName('wpwl-control-city')[0])
            }
            if (document.getElementsByClassName('wpwl-control-stateText')?.length) {
              document.getElementsByClassName('wpwl-control-country')[0].before(document.getElementsByClassName('wpwl-control-stateText')[0])
            }
            if (document.getElementsByClassName('wpwl-control-postcode')?.length) {
              document.getElementsByClassName('wpwl-control-country')[0].before(document.getElementsByClassName('wpwl-control-postcode')[0])
            }
          }
        }
      if(this.$route.query?.action === 'card-added') {
        // finish adding card
        this.verifyCardAdding()
          .finally(() => {
            // remove adding cart query result to prevent reuse
            this.$router.replace({query: undefined}) 
            this.getUserCards()
          })
      }
      else {
        this.getUserCards()
      }
    },
    methods: {

      onBack() {
        if(this.step === 'start') {
          this.$emit('goBack')
        }
        else {
          this.step = 'start'
        }
      },

      getUserCards () {
        this.cardsLoading = true
        return this.API.geAxcessUserCards()
          .then(data => {
            console.log(data)
            this.userCardList = data?.cards
          })
          .catch(err => {
            console.log('geAxcessUserCards error', err)
            this.$toast.error('Something went wrong. Please try again later')
          })
          .finally(()=>{
            this.cardsLoading = false
          })
      },

      verifyCardAdding() {
        console.log('DEBUG verify', this.$route.query.id)
        return new Promise((resolve, reject)=>{
          const checkoutId = this.$route.query.id // axcess checkout id after redirect
          if (!checkoutId) {
            this.$toast.error('Something went wrong. Please try again later')
            resolve({})
          }
          else {
            this.API.getAxcessPaymentStatus(checkoutId, true)
            .then((data) => {
              if (data?.result?.status === 0) {
                this.$toast.success('Card has been added.')
              }
              else if ( data?.result?.status === 1 ) { 
                this.$toast.warning('Transaction pending.')
              }
              else {
                // const msg = data?.result?.description || 'Something went wrong. Please try again later'
                const msg = 'Something went wrong. Please try again later'
                this.$toast.error(msg)
              }
              resolve(data)
            })
            .catch((error) => {
              this.$toast.error('Something went wrong. Please try again later')
              reject(error)
            })
          }
        })
      },

      addCard() {
        const model = {
          registerCard: true
        }
        this.createCheckout(model, 'add-card')
      },
     
      onSavedCardClick(card) {
        // this.$emit('cardClick', card)
        const model = {
          amount: Number(this.amount)?.toFixed(2), // mandatory
          cardId: card.id // card ID from the retrieved card list
        }
        this.createCheckout(model, 'pay')

      },
      onCardDelete(card) {
        this.cardsLoading = true
        console.log('DEBUG', card)
         this.API.axcessDeleteTokenization(card.id)
          .then(data=>{
            if (data.success) {
              this.$toast.success('Card has been removed.')
              this.getUserCards()
            }
            else {
              this.$toast.error('Something went wrong. Please try again later')
            }
          })
          .catch((err) => {
            this.$toast.error('Something went wrong. Please try again later')
            console.error('axcessDeleteTokenization err', err)
          })
          .finally(() => this.getUserCards())
      },

      createCheckout(model, step) {
        this.loading = true
        return this.API.getCheckoutAxcess(model)
            .then(data=>{
              if (new Date().getTime() < moment(data.timestamp).add(30, 'minutes').valueOf()) {
                
                window['wpwlOptions']['billingAddress'] = {
                  country: data.billingDetails.country,
                  state: data.billingDetails.state,
                  city: data.billingDetails.city,
                  postcode: data.billingDetails.postcode,
                  street1: data.billingDetails.street1,
                  street2: data.billingDetails.street2,
                }
                window['wpwlOptions']['mandatoryBillingFields'] = {
                  country: true,
                  state: true,
                  city: true,
                  postcode: true,
                  street1: true,
                  // street2: false
                }
                this.paymentScriptUrl = data.url
                this.step = step
              } else {
                  this.$toast.warning("Time to pay is over!")
                  this.paymentScriptUrl = null
                  this.step  = 'start'
              }
            })
            .catch(err => {
              this.$toast.error('Something went wrong. Please try again later')
              console.log('getCheckoutAxcess error', err)
            })
            .finally(() => {
              this.loading = false
            })
      }


    }
    
  }
</script>
  
<style scoped lang="scss">
  .btn-back {
    font-size: 1.125rem;
    font-weight: 600;
    margin: 0 1.5rem;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 1rem 1fr;
  }
  .title {
    font-size: 1.125rem;
    font-weight: 600;
    text-align: center;
    margin: 0.5rem 0;
  }
  .card-list-wr {
    position: relative;
    min-height: 5.6875rem;
  }
  .no-cards {
    display: flex;
    // grid-template-columns: 1rem 3.375rem 1fr;
    align-items: center;
    background-color: #2e2e2e;
    border-radius: 0.25rem;
    padding: 0.25rem 1rem;
    justify-content: center;
    height: 5.625rem;
  }

  .loading-shade {
    opacity: 1;

    .opacity-50 {
      opacity: 0.5;
    }
  }
</style>